import {
  locationIdFormat,
  processingSessionIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { ProcessingSessionItem } from "./processing-session";

export const addUndeclaredItemToProcessingSession = {
  name: "addUndeclaredItemToProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema.optional(),
  }),
  output: z.object({ sessionItem: ProcessingSessionItem }),
};
